import type { KeyboardEvent } from "react";
import { EditorSection } from "@/components/ListingFields/EditorSectionHeader";
import { TaglineField, taglineFieldCopy } from "@/components/ListingFields/TaglineField";

const LISTING_TYPE = "product" as const;

export interface ProductTaglineEditorProps {
  /** Field error for the tagline input, or undefined when valid. */
  error?: string;
  /** Called with the new value on every change. */
  onChange: (value: string) => void;
  /** Key handler; the container uses it to save on Enter. */
  onKeyDown?: (event: KeyboardEvent) => void;
  /** Current value of the tagline field. */
  value: string;
}

export function ProductTaglineEditor({ error, onChange, onKeyDown, value }: ProductTaglineEditorProps) {
  return (
    <EditorSection {...taglineFieldCopy(LISTING_TYPE)}>
      <TaglineField error={error} listingType={LISTING_TYPE} onChange={onChange} onKeyDown={onKeyDown} value={value} />
    </EditorSection>
  );
}
